module.exports = __webpack_public_path__ + "img/dizajn-priprema.49045786.svg";